/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 03 2024
 **/

import { useTheme } from "@emotion/react";

import { usePersistUser } from "@/frameworks/core/persistence";
import { Column, Icon, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

export default function UnauthorizedChannel({ createdBy }: { createdBy: string }) {
	const theme = useTheme();

	const channelAdmin = usePersistUser(createdBy);

	return (
		<Column
			verticalAlign="center"
			horizonAlign="center"
			gap={12}
			css={{ width: "288px", height: "100%", margin: "auto" }}
		>
			<Icon name="CautionIcon24" fill={theme.colors.neutral_90_100} size={72} />
			<Typography typoColor="neutral_70_100" align="center" css={{ wordBreak: "keep-all" }}>
				{_T("비공개 채널은 채널 관리자 및 멤버만 이용이 가능합니다.")}
			</Typography>
			<Typography typoSize="Title3" typoColor="neutral_70_100" align="center">
				{_T("※ 채널 관리자 ({{admins}})", { admins: channelAdmin?.name })}
			</Typography>
		</Column>
	);
}
